import { createSlice } from '@reduxjs/toolkit';
import blankSurvey from '/public/data/gym/blankSurvey.json';

function initializeSurvey() {
  const surveyId = `survey-${Date.now()}`;
  return { ...blankSurvey, surveyId, isComplete: false };
}

const surveySlice = createSlice({
  name: 'survey',
  initialState: {
    surveyData: initializeSurvey(),
    activeStep: 0,
  },
  reducers: {
    setSurveyData(state, action) {
      state.surveyData = action.payload;
    },
    setActiveStep(state, action) {
      // Add this action
      state.activeStep = action.payload;
    },
    updateAnswer(state, action) {
      const { sectionIndex, questionId, answer, complete, details } =
        action.payload;
      const question =
        state.surveyData.survey.sections[sectionIndex].questions[questionId];

      if (question) {
        state.surveyData = {
          ...state.surveyData,
          survey: {
            ...state.surveyData.survey,
            sections: state.surveyData.survey.sections.map((section, i) =>
              i === sectionIndex
                ? {
                    ...section,
                    questions: {
                      ...section.questions,
                      [questionId]: { ...question, answer, complete, details },
                    },
                  }
                : section
            ),
          },
        };
      }
    },
    markComplete(state) {
      state.surveyData.isComplete = true;
    },
  },
});

export const { setSurveyData, setActiveStep, updateAnswer, markComplete } =
  surveySlice.actions;
export default surveySlice.reducer;
